import { ScrollTrigger } from "gsap/ScrollTrigger";

// Export home page animations
export {
  animateMissionCard as animateHomeMissionCard,
  animateWhyUsGrid,
  animateFounderCard,
  animateExpertiseCard,
  animateServicesSection,
} from './home';

// Export about page animations
export {
  animateHeroCard,
  animatePoeticSection,
  animateFounderSection,
  animateMissionCard as animateAboutMissionCard,
  animateValuesSection,
} from './about';

// Export services page animations
export {
  animateServicesGrid,
  animateSubServices,
  animateMobileServices,
  animateServicesHeader,
  animateServiceCards,
} from './services';

// Export team page animations
export {
  animateTeamIntro,
  animateTeamMembers,
  animateTrustSection,
  animateCTASection,
} from './team';

// Export contact page animations
export {
  animateContactHeader,
  animateContactForm,
  animateContactInfo,
  animateMapSection,
} from './contact';

// Export component animations
export { animateBanner } from './bannerAnimations';
export { animateHeadingBox } from './headingBoxAnimations';


// Utility function to refresh ScrollTrigger
export const refreshScrollTrigger = () => {
  const timer = setTimeout(() => {
    ScrollTrigger.refresh();
  }, 500);
  
  return () => clearTimeout(timer);
};

